import { ADD_TO_WISH_LIST, GET_WISH_LIST_ITEM_INFO } from "../actionTypes";

const initialState = {
  wishList: {},
  wishListInfo: [],
};

export default function wishListReducer(state = initialState, { type, payload }) {
  switch (type) {
    case ADD_TO_WISH_LIST: {
      return {
        ...state,
        wishList: { ...state.wishList, ...payload },
      };
    }
    case GET_WISH_LIST_ITEM_INFO: {
      return {
        ...state,
        wishListInfo: payload,
      };
    }
    default:
      return state;
  }
}
